import { createSHA256 } from 'hash-wasm';

export async function getFileHash(file: File, chunkSize = 5 * 1024 * 1024) {
  const sha256 = await createSHA256();
  sha256.init();

  let offset = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    const buffer = await chunk.arrayBuffer();
    sha256.update(new Uint8Array(buffer));
    offset += chunkSize;
  }

  return sha256.digest('hex');
}
